import React from 'react'
import { CONTROLDText } from 'ui/CONTROLD'
import { Paragraph } from 'theme-ui'
import { FAQItem } from 'components/FrequentlyAskedQuestions'
import StyledLink from 'components/Organization/LandingPageCommonComponents/StyledLinks'

export const frequentlyAskedQuestions: FAQItem[] = [
  {
    question: `What do the sections mean?`,
    answer: (
      <Paragraph>
        Your current IP address, DNS resolver, and proxy sections give you your current ISP assigned
        IPv4 and IPv6 (if available) addresses, your Device ID (if using a premium resolver), and
        your latency to the closest Control D server.
      </Paragraph>
    ),
  },
  {
    question: `How do I check if the ${CONTROLDText}’s server network is up and running?`,
    answer: (
      <Paragraph>
        Visit the <StyledLink to="/network">{CONTROLDText} network page</StyledLink> for real-time
        status of all our server locations.
      </Paragraph>
    ),
  },
  {
    question: `Will a potentially unsafe website alter my DNS configuration?`,
    answer: (
      <Paragraph>
        When you’re using {CONTROLDText}’s resolvers, be sure to turn the{' '}
        <StyledLink to="/features/malware-blocking">malware filter</StyledLink> on for automatic
        blocking of all harmful websites. Additionally, you could also run our{' '}
        <StyledLink to="/tools/website-link-checker">website link checker</StyledLink> test to be
        sure before accessing a suspicious site.
      </Paragraph>
    ),
  },
]
